module.exports = __webpack_public_path__ + "img/gdjieshao.d97616a3.png";